import type { Mode } from './types.js'

export type ModeName = 'ionian' | 'dorian' | 'phrygian' | 'lydian' | 'mixolydian' | 'aeolian' | 'locrian'

/** Get the name of a mode from the degree */
export const ALL_MODES: Record<ModeName, Mode> = {
  ionian: {
    mode: 'I',
    intervals: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'],
    chordTypes: {
      I: '',
      II: 'm',
      III: 'm',
      IV: '',
      V: '',
      VI: 'm',
      VII: 'dim',
      VIII: '',
    },
  },

  dorian: {
    mode: 'II',
    intervals: ['I', 'II', 'bIII', 'IV', 'V', 'VI', 'bVII', 'VIII'],
    chordTypes: {
      I: 'm',
      II: 'm',
      III: '',
      IV: '',
      V: 'm',
      VI: 'dim',
      VII: '',
      VIII: 'm',
    },
  },

  phrygian: {
    mode: 'III',
    intervals: ['I', 'bII', 'bIII', 'IV', 'V', 'bVI', 'bVII', 'VIII'],
    chordTypes: {
      I: 'm',
      II: '',
      III: '',
      IV: 'm',
      V: 'dim',
      VI: '',
      VII: 'm',
      VIII: 'm',
    },
  },
  lydian: {
    mode: 'IV',
    intervals: ['I', 'II', 'III', '#IV', 'V', 'VI', 'VII', 'VIII'],
    chordTypes: {
      I: '',
      II: '',
      III: 'm',
      IV: 'dim',
      V: '',
      VI: 'm',
      VII: 'm',
      VIII: '',
    },
  },
  mixolydian: {
    mode: 'V',
    intervals: ['I', 'II', 'III', 'IV', 'V', 'VI', 'bVII', 'VIII'],
    chordTypes: {
      I: '',
      II: 'm',
      III: 'dim',
      IV: '',
      V: 'm',
      VI: 'm',
      VII: '',
      VIII: '',
    },
  },

  aeolian: {
    mode: 'VI',
    intervals: ['I', 'II', 'bIII', 'IV', 'V', 'bVI', 'bVII', 'VIII'],
    chordTypes: {
      I: 'm',
      II: 'dim',
      III: '',
      IV: 'm',
      V: 'm',
      VI: '',
      VII: '',
      VIII: 'm',
    },
  },

  locrian: {
    mode: 'VII',
    intervals: ['I', 'bII', 'bIII', 'IV', 'bV', 'bVI', 'bVII', 'VIII'],
    chordTypes: {
      I: 'dim',
      II: '',
      III: 'm',
      IV: 'm',
      V: '',
      VI: '',
      VII: 'm',
      VIII: 'dim',
    },
  },
}

export type ModeType = keyof typeof ALL_MODES
export const MODE_NAMES = Object.keys(ALL_MODES) as ModeType[]
